export var SizeType;
(function (SizeType) {
    SizeType["xxs"] = "xxs";
    SizeType["xs"] = "xs";
    SizeType["s"] = "s";
    SizeType["m"] = "m";
    SizeType["l"] = "l";
    SizeType["xl"] = "xl";
    SizeType["xxl"] = "xxl";
    SizeType["xxxl"] = "xxxl";
})(SizeType || (SizeType = {}));
// note: keep aligned with SizeType, but then negative
export var NegativeSizeType;
(function (NegativeSizeType) {
    NegativeSizeType["-xxs"] = "-xxs";
    NegativeSizeType["-xs"] = "-xs";
    NegativeSizeType["-s"] = "-s";
    NegativeSizeType["-m"] = "-m";
    NegativeSizeType["-l"] = "-l";
    NegativeSizeType["-xl"] = "-xl";
    NegativeSizeType["-xxl"] = "-xxl";
    NegativeSizeType["-xxxl"] = "-xxxl";
})(NegativeSizeType || (NegativeSizeType = {}));
//# sourceMappingURL=Spacing.types.js.map